// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OptionPutCall;
(function (OptionPutCall) {
    OptionPutCall[OptionPutCall["OPTION_NONE"] = -1] = "OPTION_NONE";
    OptionPutCall[OptionPutCall["OPTION_CALL_VANILLA"] = 0] = "OPTION_CALL_VANILLA";
    OptionPutCall[OptionPutCall["OPTION_PUT_VANILLA"] = 1] = "OPTION_PUT_VANILLA";
})(OptionPutCall || (OptionPutCall = {}));
